import get from 'lodash/get';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';
import TextArea from '@wix/da-ds/pkg/formControls/dsPresets/TextArea';

function TextAreaField({
  name,
  label,
  defaultValue = '',
  rows = 5,
  details: detailsProp = '',
  ...props
}) {
  const id = useId();
  const { t } = useTranslation();
  const { control, errors } = useFormContext();
  const error = get(errors, name);

  const {
    field: { ref, ...inputProps },
  } = useController({
    name,
    control,
    defaultValue,
  });

  const details = error ? t(error.message) : detailsProp;

  return (
    <TextArea
      id={id}
      label={label}
      rows={rows}
      {...props}
      {...inputProps}
      details={details}
      validationResult={error ? 'error' : undefined}
      ref={ref}
    />
  );
}

export default TextAreaField;
